import InvoicingTask from './InvoicingTask';
import Subtotals from './Subtotals';

export default class InvoicingSummary {
  subtotals = new Subtotals();
  tasks: Array<InvoicingTask> = [];
}
